import { render, staticRenderFns } from "./ProposalGenerate.vue?vue&type=template&id=6ad887e6&scoped=true&"
import script from "./ProposalGenerate.vue?vue&type=script&lang=js&"
export * from "./ProposalGenerate.vue?vue&type=script&lang=js&"
import style0 from "./ProposalGenerate.vue?vue&type=style&index=0&id=6ad887e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad887e6",
  null
  
)

export default component.exports